export const _cpt = {
  code: '',
  codeType: 'CPT',
  effectiveDate: '',
  dictionaryName: 'CPT Codes',
  columnName: 'Code'
};

const _mod = {
  code: '',
  codeType: 'MODIFIER',
  effectiveDate: '',
  dictionaryName: 'Modifiers',
  columnName: 'Code'
};

const _icd = {
  code: '',
  codeType: 'ICD',
  effectiveDate: '',
  dictionaryName: 'ICD Codes',
  columnName: 'Code'
};

const buildDescriptionRequest = (
  invoices: AmplifyAPI.Invoice[],
  effectiveDate: string
) => {
  const accumulator = [];
  invoices.forEach(invoice => {
    invoice.transactions.forEach(txn => {
      if (txn.procedure) {
        accumulator.push({
          ..._cpt,
          code: txn.procedure.procedure_code,
          effectiveDate
        });
      }

      (txn.modifiers || []).forEach(mod => {
        accumulator.push({
          ..._mod,
          code: mod.modifier_code,
          effectiveDate
        });
      });

      (txn.diagnoses || []).forEach(diagnosis => {
        accumulator.push({
          ..._icd,
          code: diagnosis.diagnosis_code,
          effectiveDate
        });
      });
    });
  });
  return accumulator;
};

export { buildDescriptionRequest };
